// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__NMyW0","left":"Navbar_left__ofB0L","pp":"Navbar_pp__tmLQs","right":"Navbar_right__X74NF"};